"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const game_events_table_1 = __importDefault(require("../components/game_events_table"));
const game_records_table_1 = __importDefault(require("../components/game_records_table"));
const players_table_1 = __importDefault(require("../components/players_table"));
class SearchView extends HTMLElement {
    static tag = "search-view";
    constructor() {
        super();
    }
    connectedCallback() {
        document.title = "Procurar";
        this.innerHTML = `
      <form>
        <fieldset>
          <input 
            name="search" 
            required 
            place
            autofocus/>
            
          <select name="search-type">
            <option value="playerName" selected>Nome do Jogador</option>
            <option value="date">Dia da Partida(s)</option>
            <option value="eventName">Nome do Evento</option>
          </select>
          
          <button id="search" type="submit">Procurar</buton>
        </fieldset>
      </form>

      <div id="search-result"></div>
    `;
        this.select.onclick = this.selectType;
        this.select.click();
        this.form.onsubmit = this.onSubmit;
    }
    onSubmit = (evt) => {
        evt.preventDefault();
        const searchResultDiv = this.querySelector("div#search-result");
        switch (this.select.value) {
            case "playerName":
                searchResultDiv.replaceChildren(new players_table_1.default("", false, "", this.searchInput.value));
                break;
            case "date":
                searchResultDiv.replaceChildren(new game_records_table_1.default("", "", "", "", this.searchInput.valueAsDate));
                break;
            case "eventName":
                searchResultDiv.replaceChildren(new game_events_table_1.default("", this.searchInput.value));
                break;
            default:
                throw new Error("No value for this selection.");
        }
    };
    get form() {
        return this.querySelector("form");
    }
    get select() {
        return this.querySelector("select");
    }
    get searchInput() {
        return this.querySelector('input[name="search"]');
    }
    selectType = (evt) => {
        evt.preventDefault();
        const searchInput = this.searchInput;
        switch (this.select.value) {
            case "playerName":
                searchInput.placeholder = "João da Silva";
                searchInput.type = "text";
                break;
            case "date":
                searchInput.type = "date";
                break;
            case "eventName":
                searchInput.placeholder = "Copa do Brasil 2022";
                searchInput.type = "text";
                break;
            default:
                throw new Error("No value for this selection.");
        }
    };
}
exports.default = SearchView;
//# sourceMappingURL=data:application/json;base64,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